export default __webpack_public_path__ + "static/media/not_interested.959ed38d.svg";